// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"index_content-wrapper_9j8fd","text":"index_text_3CGCb"};